import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from 'components/StyledButton/StyledButton';

import logo from '../../logo.png';
import initialState from '../../redux/user/initialState';
import { setFromApi } from '../../redux/user/userSlice';
import api from '../../utils/api';
import { FormContainer, Logo, Title } from './styled';

const NoCompanyExternalPage = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleLogout = useCallback(() => {
        api.logout();
        dispatch(setFromApi(initialState));
    }, [dispatch]);

    return (
        <>
            <Logo src={logo} alt='logo' />
            <FormContainer>
                <Title variant='h4'>
                    {t('pages.no_company.title')}
                </Title>

                <p>
                    {t('pages.no_company.message')}
                </p>

                <Button onClick={handleLogout} variant='outlined' style={{ display: 'block', margin: '0 auto' }}>
                    {t('generic.logout')}
                </Button>
            </FormContainer>
        </>
    );
};

export default NoCompanyExternalPage;
